module.exports = __webpack_public_path__ + "img/bank-center-type2.bbecde8c.png";